export default [
  {
    title: 'Store Information',
    icon: 'mdi-cogs',
    to: 'SettingStoreInformation',
    keywords: ['ข้อมูลร้าน', 'สาขา', 'store', 'information']
  },
  {
    title: 'Store Setting',
    icon: 'mdi-cogs',
    to: 'StoreSetting',
    keywords: ['ตั้งค่าร้าน', 'store', 'setting']
  },
  {
    title: 'VIP Campaign Setting',
    icon: 'mdi-tag',
    to: 'CampaignSetting',
    keywords: ['แคมเปญ', 'วีไอพี', 'campaign', 'vip']
  },
  {
    title: 'Payment Channel',
    icon: 'mdi-credit-card-outline',
    to: 'AvailablePaymentChannelSetting',
    keywords: ['ช่องทางชำระเงิน', 'การชำระเงิน', 'payment', 'channel']
  },
  {
    title: 'Delivery Setting',
    icon: 'mdi-truck',
    to: 'DeliverySetting',
    keywords: ['การจัดส่ง', 'ขนส่ง', 'delivery', 'shipping']
  },
  {
    title: 'Warehouse Setting',
    icon: 'mdi-warehouse',
    to: 'WarehouseSetting',
    keywords: ['คลัง', 'คลังสินค้า', 'warehouse', 'setting']
  },
  {
    title: 'Fulfillment Setting',
    icon: 'mdi-file-table-box-outline',
    to: 'OrderFulfillmentSettingNew',
    keywords: ['จัดส่ง', 'การจัดส่ง', 'คลังจัดส่ง', 'ffm', 'fulfillment', 'warehouse']
  },
  {
    title: 'User Setting',
    icon: 'mdi-home-account',
    to: 'UserBranchSetting',
    keywords: ['ผู้ใช้', 'สิทธิ์', 'พนักงาน', 'user', 'permission', 'role']
  },
  {
    title: 'CurrencyRates',
    icon: 'mdi-cash-multiple',
    to: 'CurrencyRatesSetting',
    keywords: ['อัตราแลกเปลี่ยน', 'เงินตรา', 'currency', 'rate', 'exchange']
  },
  {
    title: 'Clear Cache',
    icon: 'mdi-cached',
    to: 'ClearCache',
    keywords: ['ล้างแคช', 'แคช', 'clear', 'cache']
  },
  {
    title: 'BC Logs',
    icon: 'mdi-microsoft-access',
    to: 'BCLogs',
    keywords: ['business central', 'log', 'บันทึก bc']
  },
  {
    title: 'BC Queues',
    icon: 'mdi-human-queue',
    to: 'BCQueues',
    keywords: ['business central', 'queue', 'คิว bc']
  },
  {
    title: 'Develop Debug',
    icon: 'mdi-wrench',
    to: 'DevSetting',
    keywords: ['ดีบัก', 'นักพัฒนา', 'develop', 'debug', 'dev']
  },
  {
    title: 'Release Note',
    icon: 'mdi-rocket',
    to: 'ReleaseNote',
    keywords: ['บันทึกการอัปเดต', 'release', 'changelog', 'note']
  },
  {
    title: 'POS Management',
    icon: 'mdi-calculator',
    to: 'PosManagement',
    keywords: ['จัดการ pos', 'หน้าร้าน', 'pos', 'management']
  },
  {
    title: 'DHL Express Setting',
    icon: 'mdi-airport',
    to: 'DHLExpressSetting',
    keywords: ['ดีเอชแอล', 'ขนส่ง', 'dhl', 'express', 'shipping']
  },
  {
    title: 'Flash Express Setting',
    icon: 'mdi-airport',
    to: 'FlashExpressSetting',
    keywords: ['flash', 'ขนส่ง', 'flash express', 'shipping']
  },
  {
    title: 'ETax And VRT Setting',
    icon: 'mdi-cash-multiple',
    to: 'ETaxAndVRTSetting',
    keywords: ['ภาษี', 'ใบกำกับภาษี', 'etax', 'vrt', 'tax']
  },
  {
    title: 'Access Logs',
    icon: 'mdi-microsoft-access',
    to: 'AccessLog',
    keywords: ['ประวัติการเข้าใช้', 'บันทึก', 'access', 'log']
  }
]
